import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Vehicle } from '@/types';

export interface VehicleHistoryEntry {
  plate: string;
  ktype: number;
  vehicle: Vehicle;
  lastUsed: number;
}

interface VehicleHistoryStore {
  entries: VehicleHistoryEntry[];
  addEntry: (plate: string, ktype: number, vehicle: Vehicle) => void;
  removeEntry: (plate: string) => void;
  clearHistory: () => void;
}

export const useVehicleHistoryStore = create<VehicleHistoryStore>()(
  persist(
    (set) => ({
      entries: [],

      addEntry: (plate, ktype, vehicle) => {
        set((state) => {
          const filtered = state.entries.filter((e) => e.plate !== plate);
          const updated = [
            { plate, ktype, vehicle, lastUsed: Date.now() },
            ...filtered,
          ].slice(0, 10);
          return { entries: updated };
        });
      },

      removeEntry: (plate) => {
        set((state) => ({
          entries: state.entries.filter((e) => e.plate !== plate),
        }));
      },

      clearHistory: () => {
        set({ entries: [] });
      },
    }),
    {
      name: 'autofrance-reg-history',
    }
  )
);
